import { createUseStyles } from 'react-jss'
import { colors } from '../../common/colors'

export const style = {
  text: {
    fill: colors.gunMetal,
    fontSize: 13,
    textAnchor: 'middle'
  }
}

export const useStyles = createUseStyles(style)
